const beUrl = window.location.origin.replace('://', '://api.');

export const getEndpoint = (endpoint: string): string => (process.env.NODE_ENV === 'development' ? endpoint : `${beUrl}${endpoint}`);
